module.exports = __webpack_public_path__ + "static/media/traffic-moderate.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/traffic-moderate.svg
// module id = 867
// module chunks = 0